import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React from "react";

const SelectBoxV2 = ({ value, onChange, selectObject, hideLabel }) => {
  const label = selectObject?.label || "";
  const size = selectObject?.smallSize ? "small" : "medium";
  const items = selectObject?.menuItems ?? [];

  return (
    <FormControl fullWidth size={size}>
      {!hideLabel && <InputLabel id="select-label">{label}</InputLabel>}
      <Select
        labelId={!hideLabel ? "select-label" : undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label={!hideLabel ? label : undefined}
      >
        {items.map((item, index) => {
          const isObj = item && typeof item === "object";
          const itemValue = isObj ? item.value : item;
          const itemLabel = isObj ? item.label : item;
          return (
            <MenuItem key={index} value={itemValue}>
              {itemLabel}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectBoxV2;
